import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Multiselect from 'components/Multiselect';
import { AppSettings } from '../../constants';
import Translate from 'components/translate';

class SubcontractorPunchListFilter extends Component {
  static propTypes = {
    ProjectSelectList: PropTypes.array,
    onFetchProject: PropTypes.func,
    onSearchRFS: PropTypes.func,
    sso: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      project: null,
      isLoadingProject: false,
      statusSelectList: [
        { label: 'New', value: 3 },
        { label: 'Open', value: 0 },
        { label: 'Declined', value: 1 },
        { label: 'Closed', value: 2 },
        { label: 'Scheduled', value: 4 }
      ]
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ProjectSelectList && this.state.isLoadingProject) {
      this.setState({ isLoadingProject: false });
    }
  }

  onFetchProject = () => {
    this.setState(
      {
        isLoadingProject: true
      },
      () => {
        this.props.onFetchProject(() => {
          this.setState({ isLoadingProject: false });
        });
      }
    );
  };

  onSelectProject = value => {
    this.setState(
      {
        project: value
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  onSelectStatus = value => {
    this.setState(
      {
        status: value
      },
      () => {
        this.props.onSearchRFS(this.mapParams());
      }
    );
  };

  mapParams = () => {
    const projectIds = [];
    if (this.state.project) {
      this.state.project.map(e => {
        projectIds.push(e.value);
      });
    }
    const status = [];
    if (this.state.status) {
      this.state.status.map(e => {
        status.push(e.key);
      });
    }

    let params = {};
    if (projectIds.length) {
      params['ProjectIds'] = projectIds.toString();
    }
    if (status.length) {
      params['Status'] = status.toString();
    }

    return params;
  };

  render() {
    return (
      <div className='lot-filter-wrapper box-form-siteone clearfix'>
        <h2 className='col-sm-12' style={{ fontSize: 20, fontWeight: 400 }}>
          Filters
        </h2>
        <div className='row' style={{ paddingLeft: 15, paddingRight: 15 }}>
          {/*
           * Projects dropdown
           */}
          <div className='col-sm-3 lot-filter-block'>
            <label className='col-sm-12 control-label'>
              <Translate translateKey='project' plurals capitalize />
            </label>
            <div className='col-sm-12 control-label'>
              <Multiselect
                placeholder='Any'
                items={this.props.ProjectSelectList.map(item => ({
                  label: item.text,
                  value: item.value
                }))}
                value={this.state.project}
                onChange={this.onSelectProject}
                onRemote={this.onFetchProject}
                isLoading={this.state.isLoadingProject}
                ref={ref => {
                  this.project = ref;
                }}
              />
            </div>
          </div>

          {/*
           * Statuses dropdown
           */}
          <div className='col-sm-3 lot-filter-block'>
            <label className='col-sm-12 control-label'>Status</label>
            <div className='col-sm-12 control-label'>
              <Multiselect
                placeholder='Any'
                items={AppSettings.RFS_STATUS_VALUE}
                value={this.state.status}
                onChange={this.onSelectStatus}
                labelKey='value'
                ref={ref => {
                  this.status = ref;
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SubcontractorPunchListFilter;



// WEBPACK FOOTER //
// ./src/Punch-List/Components/SubcontractorPunchListFilter.js